import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "bg-white rounded-4 shadow p-4 mb-5" }
const _hoisted_2 = { class: "fw-bold fs-5 mb-5" }
const _hoisted_3 = { class: "fs-7" }
const _hoisted_4 = { class: "fs-7 mb-5" }
const _hoisted_5 = { class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4" }
const _hoisted_6 = { class: "w-max-content col-lg-2 col-form-label" }
const _hoisted_7 = { class: "w-max-content col-lg-1 col-form-label" }
const _hoisted_8 = { class: "row mx-0 px-0 col-lg-8" }
const _hoisted_9 = { class: "col-lg-12" }
const _hoisted_10 = ["placeholder"]
const _hoisted_11 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_12 = { class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4" }
const _hoisted_13 = { class: "w-max-content col-lg-2 col-form-label" }
const _hoisted_14 = { class: "w-max-content col-lg-1 col-form-label" }
const _hoisted_15 = { class: "row mx-0 px-0 col-lg-8" }
const _hoisted_16 = { class: "col-lg-12" }
const _hoisted_17 = {
  key: 0,
  class: "invalid-feedback d-block while-spaces"
}
const _hoisted_18 = { class: "row mx-0 px-0 d-flex justify-content-center" }
const _hoisted_19 = { class: "col-lg-6 d-flex justify-content-lg-end justify-content-center mb-4 mb-lg-0" }
const _hoisted_20 = { class: "col-lg-6 d-flex justify-content-lg-start justify-content-center" }

import { translate } from '@/languages/i18n'
import Status from '@/components/status/index.vue'
import Button from '@/components/button/index.vue'
import { Modal } from 'bootstrap'
import { getMessage } from '@/constants/messageCode.ts'
import InputErrorMessage from '@/components/input-error-message/InputErrorMessage.vue'
import ConfirmModal from '@/views/community-admin/user-management/create-user/components/ConfirmModal.vue'
import CreateSuccessModal from '@/views/community-admin/user-management/create-user/components/CreateSuccessModal.vue'
import Breadcrumb from '@/components/breadcrumb/index.vue'

//validate
import useVuelidate from '@vuelidate/core'
import { required, email, minLength } from '@vuelidate/validators'
import { customMaxLength, scrollToErrors } from '@/utils'

//constant
import { DEFAULT_MIN_LENGTH, MAX_WORD, MIN_LENGTH_EMAIL, MAX_LENGTH_EMAIL } from '@/constants/number'
import { computed, onMounted, ref, nextTick } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { REGEX_EMOJI } from '@/constants/regex'
import communityManagerServices from '@/services/community-managers.services'
import { debounce } from 'lodash'
import commonService from '@/services/common.service'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute()
const router = useRouter()
const PAGE_LIST_PATH = `/community/communities/${router.currentRoute.value.params?.id}/managers?management_no=asc`

const breadcrumb = [
  {
    content: translate('CC10home'),
    to: `/community/communities/${router.currentRoute.value.params?.id}/dashboard`,
    active: false,
  },
  {
    content: translate('settings'),
    to: '',
    active: false,
  },
  {
    content: translate('CC10listOfAdmin'),
    to: PAGE_LIST_PATH,
    active: false,
  },

  {
    content: translate('adminRegistration'),
    to: '',
    active: true,
  },
]

const serverError = ref<string>('')
const modalConfirm = ref()
const modalSuccess = ref()

//TODO: SC50

const rules = computed(() => {
  return {
    department_name: {
      required,
      minLength: minLength(DEFAULT_MIN_LENGTH),
      maxLength: (value: string) => customMaxLength(value, MAX_WORD),
      pictograms: function (value) {
        if (!value) {
          return true
        }
        return REGEX_EMOJI.test(value)
      },
    },
    email: {
      required,
      minLength: minLength(MIN_LENGTH_EMAIL),
      maxLength: (value: string) => customMaxLength(value, MAX_LENGTH_EMAIL),
      email,
      pictograms: function (value) {
        if (!value) {
          return true
        }
        return REGEX_EMOJI.test(value)
      },
    },
  }
})

const formData = ref({
  department_name: '',
  email: '',
})

const v$ = useVuelidate(rules, formData)
const loading = ref(false)

const onSubmit = async (): Promise<void> => {
  v$.value.$touch()
  loading.value = true

  isCheckedNGWords.value = false
  await checkNGKeyDepartmentName()
  while (!isCheckedNGWords.value) {
    await new Promise((resolve) => setTimeout(resolve, 200))
  }

  // 2022/09/22 PhucNV Fixbug button confirm keeps showing circle marks UAT#4484: CC20(Ph2-R20220930)
  if (v$.value.$invalid || ngKeyDepartmentName.value) {
    loading.value = false
    nextTick(() => {
      scrollToErrors()
    })
    return
  }

  const res = await communityManagerServices.checkSameEmailAdminEmployee(route.params?.id, { email: formData.value.email })
  if (res.status === 200) {
    modalConfirm.value?.show()
    loading.value = false
    return
  } else if (res.status !== 200) {
    serverError.value = res?.response?.data?.data[0]?.message_code
  }

  loading.value = false
}

const messageModalCompleted = (status: string): void => {
  serverError.value = status
  modalConfirm.value?.hide()
  modalSuccess.value?.show()
}

const resetForm = (): void => {
  v$.value.$reset()
  Object.assign(formData.value, {
    department_name: '',
    email: '',
  })
}

onMounted(() => {
  modalConfirm.value = new Modal(document.getElementById('modalConfirm'))
  modalSuccess.value = new Modal(document.getElementById('createAdminSuccess'))
})

// 2022/09/13 CW-Phuong Fix for horizontal fixing#1: CC20
const clearErrorMessage = () => {
  if (serverError.value) {
    serverError.value = ''
  }
}
const isCheckedNGWords = { value: false }
const ngKeyDepartmentName = ref<boolean>(false)
const checkNGKeyDepartmentName = debounce(async () => {
  const queryData = { sentence: v$.value.department_name.$model }
  try {
    const data = await commonService.sendNGWordCheck(queryData)
    ngKeyDepartmentName.value = data.data?.data?.has_ngword
  } catch (error) {
    console.log(error)
  } finally {
    isCheckedNGWords.value = true
  }
}, 200)

const backToPageList = () => {
  router.push(PAGE_LIST_PATH)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Breadcrumb, { breadcrumb: breadcrumb }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h1", _hoisted_2, _toDisplayString(_unref(translate)('adminRegistration')), 1),
      _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(translate)('adminRegistrationAdminUser')), 1),
      _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(translate)('adminRegistrationAdminUsesDes1')), 1),
      _createElementVNode("form", {
        onSubmit: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("label", _hoisted_6, _toDisplayString(_unref(translate)('SB20belong')), 1),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(Status)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                name: "belongs",
                class: _normalizeClass(['form-control', ngKeyDepartmentName.value || _unref(v$).department_name.$error ? 'is-invalid' : '']),
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(v$).department_name.$model) = $event)),
                onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(checkNGKeyDepartmentName) && _unref(checkNGKeyDepartmentName)(...args))),
                placeholder: _unref(translate)('requireDepartment')
              }, null, 42, _hoisted_10), [
                [
                  _vModelText,
                  _unref(v$).department_name.$model,
                  void 0,
                  { trim: true }
                ]
              ]),
              (ngKeyDepartmentName.value && !_unref(v$).department_name.$error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
                : _createCommentVNode("", true),
              _createVNode(InputErrorMessage, {
                title: _unref(translate)('SB20belong'),
                params: [1, 100],
                validator: _unref(v$).department_name.$errors[0]?.$validator
              }, null, 8, ["title", "validator"])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("label", _hoisted_13, _toDisplayString(_unref(translate)('email')), 1),
          _createElementVNode("div", _hoisted_14, [
            _createVNode(Status)
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                name: "email",
                class: _normalizeClass([['form-control', _unref(v$).email.$error ? 'is-invalid' : ''], "form-control"]),
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(v$).email.$model) = $event)),
                placeholder: "sample@yelloop.jp",
                onKeyup: clearErrorMessage,
                onChange: clearErrorMessage
              }, null, 34), [
                [
                  _vModelText,
                  _unref(v$).email.$model,
                  void 0,
                  { trim: true }
                ]
              ]),
              _createVNode(InputErrorMessage, {
                title: 'email',
                validator: _unref(v$).email.$errors[0]?.$validator,
                params: [_unref(MIN_LENGTH_EMAIL), _unref(MAX_LENGTH_EMAIL)]
              }, null, 8, ["validator", "params"]),
              (serverError.value && !_unref(v$).email.$error)
                ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_unref(getMessage)(serverError.value)), 1))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createVNode(Button, {
              title: _unref(translate)('back'),
              type: 'secondary',
              onClick: backToPageList
            }, null, 8, ["title"])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createVNode(Button, {
              title: _unref(translate)('confirm'),
              type: 'secondary',
              onClick: onSubmit,
              disabled: loading.value,
              loading: loading.value
            }, null, 8, ["title", "disabled", "loading"])
          ])
        ])
      ], 32)
    ]),
    _createVNode(ConfirmModal, {
      data: formData.value,
      reset: resetForm,
      messageModalCompleted: messageModalCompleted
    }, null, 8, ["data"]),
    _createVNode(CreateSuccessModal, { serverError: serverError.value }, null, 8, ["serverError"])
  ], 64))
}
}

})